import React from 'react';
import { TextCursorInput } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { TabBtn } from '../../shared/ui/tab-btn';

export const AutoFitTextButton: React.FC = () => {
  const { addAutoFitText } = useEditorCanvas();
  return <TabBtn onClick={addAutoFitText} label='AutoFit' icon={<TextCursorInput size={18} />} />;
};
